*,
*:before,
*:after {
    box-sizing: border-box;
}

es-table-detail-header {
    display: flex;
    flex-direction: row;
    padding-bottom: 20px;
    border-bottom: 1px solid var(--color-shade-30);
    min-height: 61px;
    align-items: center;
    justify-content: center;
}

.header_title {
    font-size: 22px;
    font-weight: 300;
    color: var(--color-title-2);
    margin: 0;
}

.header_actions {
    display: flex;
    flex-direction: row;
    margin-left: auto;
}
